import { SafeAreaView } from "react-native";

import AuthStyle from "../styles/auth.style";

const AuthLayout = ({ children }) => {
  return <SafeAreaView style={AuthStyle.Container}>{children}</SafeAreaView>;
};

export default AuthLayout;
